import { render, staticRenderFns } from "./PatientView.vue?vue&type=template&id=40536ebf&"
import script from "./PatientView.vue?vue&type=script&lang=js&"
export * from "./PatientView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports